import React from 'react'
import Link from 'gatsby-link'

import Chilly from '../components/Chilly'
import styled, { keyframes } from "styled-components"

const Background = styled.div`
  overflow: hidden;
`

const MovingPage = styled.div`
  background-color: white;
  transition: transform 1s;
  transform-origin: top right;
  &[data-open='true'] {
    transform: rotate(30deg);
  }
`

class Template extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      chillyActive: false
    }
    this.closeChilly = this.closeChilly.bind(this)
    this.openChilly = this.openChilly.bind(this)
    this.toggleChilly = this.toggleChilly.bind(this)
    this.links = this.formatLinks(props.data)
  }

  componentDidMount() {
    this.injectHtmlColor();
  }

  injectHtmlColor() {
    document.querySelector("html").style.backgroundColor = "#dcecf3";
  }

  closeChilly() {
    console.log("Closing Chilly")
    this.setState({
      chillyActive: false
    })
  }

  openChilly() {
    console.log("Opening Chilly")
    this.setState({
      chillyActive: true
    })
  }

  toggleChilly() {
    this.setState((currState) => {
      return {
        chillyActive: !currState.chillyActive
      }
    })
  }

  formatLinks(data) {
    console.log(data)
    return data.allJavascriptFrontmatter.edges.map(i => {
      return i.node
    })
  }

  render() {
    const { location, children } = this.props
    return (
      <Background>
        <MovingPage data-open={this.state.chillyActive} onClick={this.closeChilly}>
          {children()}
        </MovingPage>
        <Chilly
          onClick={this.toggleChilly}
          open={this.state.chillyActive}
          links={this.links}
        />
      </Background>
    )
  }
}

Template.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
}

export default Template

export const pageQuery = graphql`
  query InChillyQuery {
    allJavascriptFrontmatter(filter: {
      frontmatter: {
        inChilly: {
          eq: true
        }
      }
    }) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js